import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useHistory, useLocation } from "react-router-dom";
import { useGetTypeByIdQuery } from "../../api/api-hooks";
import FirmwareDownloadForm from "./FirmwareDownloadForm";
import HardwareDocumentationDisplay from "./HardwareDocumentationDisplay";

const HardwareDisplay = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  // Extract hardware type ID from URL
  const hardwareTypeId = pathname.slice(pathname.lastIndexOf("/") + 1);
  const { data: hardwareType } = useGetTypeByIdQuery({
    id: Number(hardwareTypeId),
  });
  if (hardwareType === undefined) return <CircularProgress></CircularProgress>;
  const goBack = (event: any) => {
    event.preventDefault();
    history.goBack();
  };
  return (
    <Grid container direction="column" alignItems="flex-start" spacing={1}>
      <Grid container item spacing={2} alignItems="center">
        {" "}
        <Grid item>
          <img
            src={`${process.env.PUBLIC_URL}\\LPTIconSmall.webp`}
            alt="Software Logo"
            height="80px"
          />
        </Grid>
        <Grid item>
          <Typography variant="h2">{hardwareType.typeName}</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container alignItems="center">
          <Button color="primary" onClick={goBack}>
            <ArrowBack style={{ marginRight: ".3rem" }} />
            Go Back
          </Button>
        </Grid>
      </Grid>
      <Grid item container wrap="wrap" spacing={2}>
        <FirmwareDownloadForm hardwareType={hardwareType} />
        <HardwareDocumentationDisplay hardwareType={hardwareType} />
      </Grid>
    </Grid>
  );
};

export default HardwareDisplay;
